import { AppPaths, type FeatureToggle } from "@/shared/common/enums";
import { useAppSelector, useMediaQuery } from "@/shared/hooks";
import { Spinner } from "@ab.uitools/ui-library/components/Spinner";
import type { ReactElement } from "react";
import { Navigate } from "react-router-dom";

interface FeatureToggleRouteProps {
  featureFlag: FeatureToggle;
  element: ReactElement;
  fallbackPath?: string;
}

export const FeatureToggleRoute = ({
  featureFlag,
  element,
  fallbackPath = AppPaths.Dashboard,
}: FeatureToggleRouteProps) => {
  const isDesktop = useMediaQuery();
  const { toggles, isLoaded } = useAppSelector((state) => state.featureToggle);

  if (!isLoaded) {
    return (
      <div className="full-width">
        <Spinner isFullScreen={!isDesktop} size="large"/>
      </div>
    );
  }

  const isEnabled = toggles[featureFlag];

  if (!isEnabled) {
    return <Navigate to={fallbackPath} replace/>;
  }

  return element;
};

